


























import { PartyModel, QueryModel } from '@/libs/Api';
import { CrudAction } from '@/libs/core/+state/models/crud-action';
import { CrudGetter } from '@/libs/core/+state/models/crud-getter';
import { createCrudQueryPayload } from '@/libs/core/+state/models/crud-query-payload';
import { partiesStore } from '@/libs/parties/+state/store';
import {Component, Prop, Ref, Vue, Watch} from 'vue-property-decorator';


var itemVue = Vue.component("itemTemplate", {
  template: `<span><span class='searchBox--type'>{{data.typeName}}</span><span class='searchBox--name'>{{data.name}}</span></span>`,
  data() {
    return {
      data: {}
    };
  }
});

@Component({

})
export default class SearchBox extends Vue {
  
    item: string | null = null;
    search = "";
    debounce: any = null;
    dropDownOpened = false;
    loading = false;

    @Ref() searchMenuDropdown: any;
    @Prop() groupId!: string;

    get items(): PartyModel[] {
        return [...partiesStore.useGetter(CrudGetter.Data, "searchBox")];
    }

    @Watch("search")
    searchChanged (v: string) {
        if (v != null && v.length > 0) {
            const parts = v.split(" ");
            let filters: Array<any> = [];
            for (var p of parts) {
                if (p?.length == 0)
                    continue;
                filters.push({
                    field: "firstname",
                    op: "wrap",
                    comparand: [
                        {
                            field: "firstname",
                            op: "c",
                            comparand: p.trim(),
                            junction: "or"
                        },
                        {
                            field: "lastname",
                            op: "c",
                            comparand: p.trim(),
                            junction: "or"
                        }
                    ],
                    junction: "and"
                });
            }
            clearTimeout(this.debounce);
            this.debounce = setTimeout(() => {
                partiesStore.dispatch(CrudAction.GetAll, createCrudQueryPayload<PartyModel>(undefined, filters, undefined, false, "searchBox"));
            }, 300);
        }
    }

    itemClicked (e: string) {
        if (e == null || e.length == 0)
            return;
        this.$router.push({ name: "PartyGeneral", params: { tenantId: this.$route.params.tenantId, partyId: e } });
        this.$nextTick(() => {
            this.search = "";
            this.item = null;
        });
    }


}
